/**
 * These are routes defined for the application in the form given to the react router.
 * Importantly these can include parameters, e.g. /quiz/:quizId
 */
export enum AppRoutes {
  LANDING_PAGE = '/',
  INTRO_PAGE = '/intro',
  LOGIN = '/login',
  LOGOUT = '/logout',
  AUTH_CALLBACK = '/auth-callback',
  QUIZ_PROFILE_SELECTION = '/quiz/profile-selection',
  QUIZ_QUESTION = '/quiz/question',
  DASHBOARD = '/dashboard',
  LIBRARY = '/library',
  RESOURCE_MANAGER = '/resource-manager',
  TOPIC_MANAGER = '/topic-manager',
  SANDBOX = '/sandbox',
  ERROR_404 = '/404',
  ERROR_403 = '/403',
  ERROR_500 = '/500',
}

export enum AppExternalRoutes {
  MANAGERS_DASHBOARD = 'https://universityofexeteruk.sharepoint.com/sites/DataHub/SitePages/Digital-Skills.aspx?ga=1',
}

/**
 * These are the URLs that are used in the application. They are derived from the routes above,
 * for each route there is one function that allows any parameters to be set in a typesafe way
 */
export const APP_URLS = {
  landingPage: () => AppRoutes.LANDING_PAGE,
  introPage: () => AppRoutes.INTRO_PAGE,
  login: (redirect?: string) => AppRoutes.LOGIN + (redirect ? `?redirect=${redirect}` : ''),
  quizProfileSelection: () => AppRoutes.QUIZ_PROFILE_SELECTION,
  quizQuestion: () => AppRoutes.QUIZ_QUESTION,
  dashboard: () => AppRoutes.DASHBOARD,
  library: () => AppRoutes.LIBRARY,
  resourceManager: () => AppRoutes.RESOURCE_MANAGER,
  topicManager: () => AppRoutes.TOPIC_MANAGER,
  error403: AppRoutes.ERROR_403,
  error404: AppRoutes.ERROR_404,
  error500: AppRoutes.ERROR_500,
  managersDashboard: () => AppExternalRoutes.MANAGERS_DASHBOARD,
} as const;
